(function(global) {
	'use strict';
	
	/* アイソカル - アイソカル100 & アイソカルゼリーハイカロリー script.js */
	
	document.addEventListener('DOMContentLoaded', function() {
		ISCL.onLoaded([
			setupTabsUi,
			ISCL.setupYouTube
		]);
		new Splide('.splide', {
			type: 'loop',
			rewind: true,
			rewindByDrag: true,
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			arrows: false,
		}).mount();
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize(function() {
			if (tab.tabsData !== undefined) tab.onResize();
		});
	}, false);
	
	/**
	 * 成分表のタブコンテンツ
	 -------------------------------------------------- */
	function setupTabsUi() {
		if (document.querySelector('.o-tabs') !== null) {
			//console.log('-----> setupTabsUi');
			tab.constructor();
		}
	}
	const tab = {
		tabMode: ISCL.isDesktop,
		constructor: function() {
			this.tabsData = {};
			const tabs = document.getElementsByClassName('o-tabs');
			for (let i = tabs.length; i--;) {
				this.setup(tabs[i]);
			}
			if (ISCL.isDesktop) {
				this.resetToDesktop();
			} else {
				this.resetToMobile();
			}
			// console.log(this.tabsData);
		},
		setup: function(tabs) {
			// console.log(tabs);
			const tabButton = tabs.getElementsByClassName('js-tabToggle');
			const tabContent = tabs.getElementsByClassName('tabs_content');
			let id, button, contents, cssstyle, paddingTop, paddingBtm, padding;
			for (let i = tabButton.length; i--;) {
				tabButton[i].addEventListener('click', this.onClick);
				id = tabButton[i].dataset.tab;
				button = tabButton[i].parentNode;
				contents = button.nextElementSibling;
				cssstyle = getComputedStyle(contents, null);
				paddingTop = cssstyle.getPropertyValue('padding-top');
				paddingBtm = cssstyle.getPropertyValue('padding-bottom');
				padding = parseInt(paddingTop) + parseInt(paddingBtm);
				
				// タブボタン群の中のひとつめが isDefault
				let buttons = button.parentNode.getElementsByClassName('tabs_button');
				buttons = [].slice.call(buttons);
				
				this.tabsData[id] = {
					isDefault: buttons.indexOf(button) === 0,
					isOpened: tabButton[i].parentNode.className.indexOf('is-active') !== -1,
					elm: tabs,
					btn: button,
					contents: contents,
					padding: padding,
					contentsHeight: contents.firstElementChild.clientHeight + padding
				};
			}
			//console.log(this.tabsData);
			this.tabButton = tabButton;
			this.tabContent = tabContent;
		},
		resetToDesktop: function() {
			// mobile -> desktop は content の style を削除
			let t;
			for (let i in this.tabsData) {
				t = this.tabsData[i];
				t.contents.removeAttribute('style');
				if (!t.isDefault) {
					t.isOpened = false;
					t.btn.classList.remove('is-active');
					t.contents.classList.remove('is-active');
				} else {
					t.isOpened = true;
					t.btn.classList.add('is-active');
					t.contents.classList.add('is-active');
				}
			}
		},
		resetToMobile:  function() {
			// desktop -> mobile は content をすべて height: 0 に 
			let t;
			for (let i in this.tabsData) {
				t = this.tabsData[i];
				t.isOpened = false;
				t.btn.classList.remove('is-active');
				t.contents.classList.remove('is-active');
				t.contents.style.height = 0;
			}
		},
		onResize: function() {
			if (this.tabMode === ISCL.isDesktop) return;
			if (ISCL.isDesktop) {
				this.resetToDesktop();
			} else {
				this.resetToMobile();
			}
			this.tabMode = ISCL.isDesktop;
			
			// コンテンツの高さは常に更新
			for (let i in this.tabsData) {
				this.tabsData[i].contentsHeight = this.tabsData[i].contents.firstElementChild.clientHeight + this.tabsData[i].padding;
			}
		},
		onClick: function() {
			if (ISCL.isDesktop) {
				tab.desktopUi(this.dataset.tab);
			} else {
				tab.mobileUi(this.dataset.tab);
			}
		},
		desktopUi: function(id) {
			const t = this.tabsData[id];
			const actives = t.elm.getElementsByClassName('is-active');
			
			for (let i = actives.length; i--;) {
				actives[i].classList.add('is-anim');
				actives[i].classList.remove('is-active');
			}
			t.isOpened = true;
			t.btn.classList.add('is-anim');
			t.btn.classList.add('is-active');
			t.contents.classList.add('is-anim');
			t.contents.classList.add('is-active');
		},
		mobileUi: function(id) {
			const t = this.tabsData[id];
			const actives = t.elm.getElementsByClassName('is-active');
			
			if (t.isOpened) {
				t.isOpened = false;
				t.btn.classList.remove('is-active');
				t.contents.classList.remove('is-active');
				this.pullUp(t);
			} else {
				t.isOpened = true;
				t.btn.classList.add('is-active');
				t.contents.classList.add('is-active');
				this.pullDown(t);
			}
		},
		pullUp: function(t) {
			t.contents.classList.add('is-anim');
			t.contents.style.height = t.contentsHeight + 'px';
			setTimeout(function() {
				t.contents.style.height = 0;
			}, 60);
			t.contents.addEventListener('transitionend', this.pullEnd);
		},
		pullDown: function(t) {
			t.contents.classList.add('is-anim');
			t.contents.style.height = t.contentsHeight + 'px';
			t.contents.addEventListener('transitionend', this.pullEnd);
		},
		pullEnd: function(e) {
			if (e.propertyName === 'height') {
				// 開いた時は style 削除
				const t = tab.tabsData[this.id];
				if (this.clientHeight > t.padding) {
					this.removeAttribute('style');
				}
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', tab.pullEnd);
			}
		}
	}
	
})((this || 0).self || global);